import analysis from '../assets/images/analysis.png';
import development from '../assets/images/development.png';
import integration from '../assets/images/integration.png';

export default [
  { key: 'a', title: 'Analysis', description: 'Every product realization starts with analyzing both functional as technical needs.', icon: analysis },
  { key: 'd', title: 'Development', description: 'Our core is developing your dream. We have a wide expertise to realise your product from multiple angles.', icon: development },
  { key: 'in', title: 'Integration', description: 'When going live with your product, it\'s our wish to have this done seamlessly. Continuous integration is core', icon: integration },
];
